export enum TEST_CATEGORY {
  FORZA = 'forza',
  SALTO = 'salto',
  VELOCITA = 'velocita',
  RESISTENZA = 'resistenza',
  MOBILITA = 'mobilita',
  COMPOSIZIONE = 'composizione',
  RTP_RTS = 'rtp_rts',
}

export enum TEST_DIRECTION {
  HIGHER_BETTER = 'higher_better',
  LOWER_BETTER = 'lower_better',
  CONTEXT = 'context',
}

export enum LATERALITY {
  DX = 'dx',
  SX = 'sx',
  BILATERAL = 'bilateral',
}

export enum INJURY_TYPE {
  LCA = 'lca',
  MENISCO = 'menisco',
  CAVIGLIA = 'caviglia',
  HAMSTRING = 'hamstring',
  QUAD = 'quad',
  ALTRO = 'altro',
}

export enum RTP_PHASE {
  PHASE_1 = 1,
  PHASE_2 = 2,
  PHASE_3 = 3,
  PHASE_4 = 4,
}

export enum RTP_THRESHOLD_TYPE {
  ABSOLUTE = 'absolute',
  LSI = 'lsi',
  PRE_INJURY_PCT = 'pre_injury_pct',
}
